import styled from 'styled-components'

const StyledCurrentPlanCard = styled.div`
  
`

export default StyledCurrentPlanCard
